import React from 'react';
import {Field} from "formik";
import {makeStyles,} from "@material-ui/core";
import Selectoption from "../../components/formikcomponent/SelectFieldWithLabel";
const Category  = (props) => {
  const useStyles = makeStyles(() => ({
    createUserSelect: {
      "& p": {
        maxWidth: "200px", textOverflow: "ellipsis",
        display: "inline-block", overflow: "hidden", whiteSpace: "nowrap !important",
      },
    },
  }));
const classes = useStyles();
return(
                        <Field
                      name='category'
                      options={props.categoryOptions}
                      placeholder="Category *"
                      component={Selectoption}
                      label="Category *"
                      variant="filled"
                      isSearchable={false}
                      className={classes.createUserSelect + " " + "selectstyle"}
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    />

);
};
export default Category;